const getCurrentView = () => (window.innerWidth >= 768 ? 'desktop' : 'mobile');

const initCartCheckboxForView = (view) => {
  const cartRoot = document.querySelector(`.cart--root[data-view="${view}"]`);
  if (!cartRoot) return;

  const checkboxes = cartRoot.querySelectorAll('.terms-checkbox');
  const checkoutButton = cartRoot.querySelector('.cart--checkout-button');
  const errorMessage = cartRoot.querySelector('.cart__checkbox--error');
  const termsCheckboxText = cartRoot.querySelector('.cart__checkbox--error-message ');

  if (!checkboxes.length || !checkoutButton || !errorMessage) return;

  checkoutButton.disabled = true;
  errorMessage.classList.add('cart__checkbox--error-thrown');

  checkboxes.forEach((checkbox) => {
    if (checkbox.dataset.initialized === 'true') return;
    checkbox.dataset.initialized = 'true';

    checkbox.addEventListener('change', () => {
      const isChecked = checkbox.checked;

      checkoutButton.disabled = !isChecked;
      errorMessage.classList.toggle('cart__checkbox--error-thrown', !isChecked);
      termsCheckboxText.classList.toggle('cart__checkbox--error-message', !isChecked);

      if (!isChecked) {
        errorMessage.classList.add('cart__checkbox--error-visible');
        setTimeout(() => {
          errorMessage.classList.remove('cart__checkbox--error-visible');
        }, 1000);
      }
    });
  });
};

const observeCartRoots = () => {
  document.querySelectorAll('.cart--root').forEach((cartRoot) => {
    const observer = new MutationObserver(() => {
      initCartCheckboxForView(cartRoot.dataset.view);
    });

    observer.observe(cartRoot, { childList: true, subtree: true });
  });
};

const initCartCheckbox = () => {
  const initialize = () => initCartCheckboxForView(getCurrentView());

  document.addEventListener('DOMContentLoaded', initialize);

  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(initialize, 150);
  });

  observeCartRoots();

  // Handle Shopify AJAX/cart events
  ['cart:updated', 'cart-drawer:opened', 'shopify:section:load'].forEach((event) => {
    document.addEventListener(event, initialize);
  });
};

initCartCheckbox();